import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular';
import { ToastService } from '@tcc-mono/shared/ui/services';
import { WebNotification } from '@tcc-mono/vandijk/shared/data-access/models';
import { take } from 'rxjs';
import { WebNotificationsState } from './web-notifications.state';

@Component({
  selector: 'tcc-mono-web-notifications-bell',
  standalone: true,
  imports: [CommonModule, IonicModule, FontAwesomeModule],
  templateUrl: './web-notifications-bell.component.html',
  styleUrls: ['./web-notifications-bell.component.scss']
})
export class WebNotificationsBellComponent {
  private readonly _state = inject(WebNotificationsState);
  private readonly _router = inject(Router);
  private readonly _toast = inject(ToastService);

  public readonly inbox$ = this._state.inbox$;
  public readonly count$ = this._state.count$;

  public menuOpen = false;
  public menuEvent?: Event;
  public activeTab: 'unhandled' | 'handled' = 'unhandled';

  public toggleMenu(event: Event): void {
    event.stopPropagation();
    this.menuEvent = event;
    this.activeTab = 'unhandled';
    this.menuOpen = !this.menuOpen;
  }

  public onTabChange(event: CustomEvent): void {
    this.activeTab = event.detail.value;
  }

  public onMenuDismissed(): void {
    this.menuOpen = false;
    this.menuEvent = undefined;
  }

  public open(notification: WebNotification): void {
    this.menuOpen = false;
    if (notification.link) {
      void this._router.navigateByUrl(notification.link);
    }
  }

  public handle(notification: WebNotification, event?: Event): void {
    event?.stopPropagation();
    this._state.handle(notification.id).pipe(take(1)).subscribe({
      error: () => {
        this._toast.show({
          message: 'Melding afhandelen mislukt.',
          color: 'danger',
          position: 'middle'
        });
      }
    });
  }
}
